import { Box, ButtonBase, List, ListItem, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Button } from '@uplift/ui-v2';
import { useMemo, useState } from 'react';

export type CollapsableBulletListProps = {
  listItems: React.ReactNode[];
  previewMaxItems?: number;
  seeMoreVariant?: 'button' | 'link';
};

export const CollapsableBulletList: React.VFC<CollapsableBulletListProps> = props => {
  const previewMaxItems = props.previewMaxItems ?? props.listItems.length;
  const [ open, setOpen ] = useState(false);
  const { classes } = useCollapsableBulletListStyles();

  const buttonText = open ? 'Show Less' : `Show All (${props.listItems.length})`;

  const seeMoreButton = useMemo(() => {
    if (props.listItems.length <= previewMaxItems) {
      return null;
    }

    if (props.seeMoreVariant === 'link') {

      if (open) {
        return null;
      }

      return (
        <ButtonBase className={classes.seeMoreLink} onClick={() => setOpen(true)}>
          <Typography>See more</Typography>
        </ButtonBase>
      );
    }

    return (
      <Button
        onClick={() => setOpen(p => !p)}
        color="inherit"
        fullWidth
      >
        {buttonText}&nbsp;&nbsp;{open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </Button>
    );
  }, [ buttonText, classes.seeMoreLink, open, props.listItems.length, previewMaxItems, props.seeMoreVariant ]);

  return (
    <Box>
      <List disablePadding className={classes.discList}>
        {props.listItems.slice(0, open ? props.listItems.length : previewMaxItems).map((item, index) => (
          <ListItem key={index} className={classes.discListItem}>{item}</ListItem>
        ))}
      </List>
      {seeMoreButton && (
        <Box mt={1}>
          {seeMoreButton}
        </Box>
      )}
    </Box>
  );
};

const useCollapsableBulletListStyles = makeStyles({ name: 'CollapsableBulletList' })(theme => ({
  discList: {
    listStyleType: 'disc',
    paddingLeft: theme.spacing(3),
  },
  discListItem: {
    display: 'list-item',
    padding: `${theme.spacing(0.25)} 0`,
  },
  seeMoreLink: {
    fontFamily: 'inherit',
    textDecoration: 'underline',
    padding: `${theme.spacing(0.5)} 0`,
  }
}));
